import styles from './ineligiblePopup.scss';
import CustomAnchorTag from '../../../Common/CommonComponents/CustomAnchorTag/customAnchorTag';
import SceButton from '../../../Dashboard/Common/customButton';

export default class ineligiblePopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ineligiblePopup: false,
        };
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_warning.svg';
        this.popupRef = React.createRef();
    }
    componentDidMount() {
        document.addEventListener('click', this.handClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handClickOutside);
    }
    handClickOutside = (event) => {
        if (this.popupRef.current && !this.popupRef.current.contains(event.target)) {
            { this.setState({ ineligiblePopup: false }); }
            app.analyticsService.addPageLevelData('contentCapturing', false);                                    
        }
    };
    openInfoPopup = () => { 
        let header = this.props.heading, events = { alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:this.props.heading, search:false},linkName=this.state.ineligiblePopup ?  'close' : this.props.linkName;
        app.analyticsService.addPageLevelData('eventCapturing', events);   
        this.setState((prevState) => ({ ineligiblePopup: !prevState.ineligiblePopup }),()=>{
            setTimeout(function () {
                window.aUtils ? window.aUtils.sendAAEvent("link", `settings|billing_payment|none|${header}|tooltip|${linkName}`) : null;
            }, 1500);
        }); 
    }
    toolTipKeyPress = (e) => {
        if (e.key === "Enter") {
            this.openInfoPopup();
        }
    }
    displayContent = () => {
        return (
            <div>
                <div>
                <button className={styles.sceCloseButton} type="button" onClick={this.openInfoPopup}><img className={styles.scePopupCloseIcon} src={this.closeIcon} alt="Icon" /></button><br />
                </div>
                <div className={styles.sceErrSection}>
                    <img className={styles.sceErrWarnImg} src={this.warningImg} alt="Icon" />
                    <p className={styles.sceErrMsg}>{this.props.heading}</p>
                </div>
                <div className={styles.sceIneligiblePopupContent} id='dssIneligiblePopupContent'>
                    {this.props.content}
                </div>
                <div className={styles.sceButtonSec}>
                    <SceButton buttonType='sceLight' value={"OK"} onClick={this.openInfoPopup} />
                </div>
            </div>
        );
    }
    render() {
        return (
            <div ref={this.popupRef}>
                <div>
                    <CustomAnchorTag isUnderline={this.props.isUnderline} isBold={this.props.isBold} linkName={this.props.linkName} onClick={this.openInfoPopup} tabIndex={0} onKeyPress={(e) => this.toolTipKeyPress(e)} />
                    {this.state.ineligiblePopup ?
                        <div className={styles.scePopupOverlay}>
                            <div className={styles.scePopupOverlayContent}>
                                <div className={styles.scePopupBox}>
                                    <div className={styles.scePopupContentArea}>
                                        <div className={styles.scePopupContent}>
                                            {this.displayContent()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : null}
                </div>
            </div>
        );
    }
}


